"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.drawer.preview': 'Content & Preview',
    'socialMediaPlan.drawer.ai': 'AI Analysis',
    'socialMediaPlan.drawer.platforms': 'Platforms',
    'socialMediaPlan.drawer.date': 'Date',
    'socialMediaPlan.drawer.type': 'Type',
};
